import { isPerformanceCookieConsentGranted } from "./consentCookieUtils";
import { cookies } from "./cookies";

interface UTMParam {
  param: string;
  value: string;
}

export const paramList = {
  standard: ["source", "medium", "campaign", "term", "content"],
  utm: [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_id",
    "utm_source_platform",
    "utm_creative_format",
    "utm_marketing_tactic",
  ],
};
export const flatParamList = Object.values(paramList).flat();

export const paramRegex = new RegExp(`^(${flatParamList.join("|")})$`);

export const applyUTMParamsForLoginButtons = (context: HTMLElement) => {
  const el = context instanceof HTMLElement ? context : context[0];
  if (!el) {
    return;
  }
  const targetedButtons: NodeListOf<HTMLLinkElement> =
    el.querySelectorAll(
      ".comp-button[data-login-link='true'] a.button",
    );

  const params: UTMParam[] | null = isPerformanceCookieConsentGranted()
    ? cookies.get("UTM_PARAMS")
      ? JSON.parse(cookies.get("UTM_PARAMS"))
      : null
    : mapUTMParamsToParamObject();

  if (params && isAnyParamsFound(params)) {
    targetedButtons.forEach((element) => {
      const href = element.getAttribute("href");
      const url = new URL(href);

      params.forEach((param) => {
        url.searchParams.set(param.param, param.value);
      });

      element.href = url.href;
    });
  }
};

export const mapUTMParamsToParamObject = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const utmParams: UTMParam[] = [];

  for (const [key, value] of searchParams) {
    const match = key.match(paramRegex);

    if (match) {
      utmParams.push({
        param: key,
        value,
      });
    }
  }

  return utmParams;
};

export const isAnyParamsFound = (filteredParams: UTMParam[]) =>
  filteredParams.some((param) => param.value);
